<template>
	<div>
		<div
			class="flex small-margin-bottom"
			v-for="(record, r) in data.payment_plan">
			<div
				class="small-margin-right">
				#{{ r + 1 }}
			</div>
			<MaterialText
				v-model="record.payment_date"
				v-on:enter="save"
				label="Payment date"
				:disabled="saving" />
		</div>

		<div class="margin-top">
			<button
				:disabled="saving"
				class="small gray xs-margin-right"
				v-on:click="create([])">Clear</button>
			<button
				:disabled="saving"
				class="small gray xs-margin-right"
				v-on:click="create(['+1'])">Next month</button>
			<button
				:disabled="saving"
				class="small gray xs-margin-right"
				v-on:click="create(['now', '+1'])">Half now + half next month</button>
			<button
				:disabled="saving"
				class="small gray"
				v-on:click="create(['+1', '+2'])">Next month + following month</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    id: {
      required: true
    },
    data: {
      required: true
    }
  },
  data: () => ({
    saving: false
  }),
  methods: {
    save () {
      Vue.$api.put('/testing/order/' + this.id + '/payment-plan', {
        rates: this.data.payment_plan
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false
      })
    },
    create (list) {
      Vue.$api.post('/testing/order/' + this.id + '/payment-plan', {
        rates: list
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.$emit('updated')
      })
    }
  }
}
</script>
